<template>
    <v-form ref="form" class="mt-3 mx-3">
        <BaseUtil ref="util" :pageLoading="pageLoading" />
        <v-row>
            <v-col cols="12" sm="8">
                <v-text-field v-model="entry.description" v-bind="getObject('description')" label="Descrição"
                    autocomplete="off" :disabled="readOnly" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-autocomplete v-model="entry.labelType" v-bind="getObject('labelType')" label="Tipo"
                    :items="extraData.globalContext.allLabelTypes" item-value="value" item-text="text"
                    autocomplete="off" :disabled="readOnly" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-autocomplete v-model="entry.colorId" v-bind="getObject('colorId')" label="Cor"
                    :items="extraData.globalContext.allColors" item-value="id" item-text="name" clearable
                    :disabled="readOnly">
                    <template v-slot:selection="data">
                        <span>
                            <v-icon right :color="data.item.hexaCode" class="mr-2">mdi-circle</v-icon>
                            {{ data.item.name }}
                        </span>

                    </template>
                    <template v-slot:item="data">
                        <span>
                            <v-icon right :color="data.item.hexaCode" class="mr-2">mdi-circle</v-icon>
                            {{ data.item.name }}
                        </span>
                    </template>
                </v-autocomplete>

            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import BaseUtil from "@shared_components/base_util.vue";

export default {
    data() {
        return { entryAttributes: {}, pageLoading: false };
    },
    props: {
        entry: Object,
        extraData: Object,
        readOnly: { type: Boolean, default: false },
        isEdit: { type: Boolean, default: false },
        modelNameSingular: String
    },
    components: { BaseUtil },
    created() {
        this.entryAttributes = this.setupEntryAttributes(this.entry);
        if(this.extraData && this.extraData.globalContext && this.extraData.globalContext.allLabelTypes && this.extraData.globalContext.allLabelTypes.length == 1) {
            this.entry.labelType = this.extraData.globalContext.allLabelTypes[0].value;
        }else{
            this.extraData.globalContext.allLabelTypes.filter(labelType => labelType.value == this.entry.labelType).forEach(labelType => {
                this.entry.labelType = labelType.value;
            });
        }
    },
    methods: {
        getObject(element) { return this.entryAttributes[element]; },
        isFormValid() { return this.$refs.form.validate(); },
        resetFormInputs() { this.$refs.form.resetValidation(); }
    }
};
</script>

<style scoped></style>